// Turkish labels and constants for the AKB Karavan ERP

export const VEHICLE_BRANDS = [
  "Fiat Ducato", "Peugeot Boxer", "Citroen Jumper",
  "Mercedes Sprinter", "Volkswagen Crafter", "Iveco Daily"
];

export const VEHICLE_VOLUMES = ["8 m³", "12 m³", "13 m³", "15 m³", "17 m³", "18 m³"];

export const VEHICLE_STATUSES = [
  { key: "new", label: "Yeni Kayıt", color: "slate" },
  { key: "tse_pending", label: "TSE Onay Bekliyor", color: "amber" },
  { key: "purchasing", label: "Satın Alma", color: "blue" },
  { key: "production", label: "Üretimde", color: "indigo" },
  { key: "qc", label: "Kalite Kontrol", color: "purple" },
  { key: "ready", label: "Teslime Hazır", color: "emerald" },
  { key: "delivered", label: "Teslim Edildi", color: "green" },
  { key: "service", label: "Serviste", color: "orange" },
];

export const EQUIPMENT_CATEGORIES = [
  "Elektrik", "Su", "Gaz", "Mobilya", "Multimedya",
  "Güvenlik", "Pencere", "Çatı Kapağı", "Dış Ekipman", "Konfor Ekipman"
];

export const PRODUCTION_DEPARTMENTS = [
  // v3.4 consolidated 5-dept flow (leak_test folded into washing_delivery Feb 2026)
  { key: "karoser", label: "1. Karoser" },
  { key: "water", label: "2. Su" },
  { key: "electrical", label: "3. Elektrik" },
  { key: "furniture", label: "4. Mobilya" },
  { key: "washing_delivery", label: "5. Yıkama & Teslimat" },
];

// Legacy dept keys — old vehicles' data may still carry these until backend
// startup migration runs. UI treats them as read-only aliases.
export const LEGACY_DEPARTMENTS = [
  { key: "accessory", label: "Aksesuar (Eski)" },
  { key: "insulation", label: "İzolasyon (Eski)" },
  { key: "furniture_prod", label: "Mobilya Üretim (Eski)" },
  { key: "furniture_asm", label: "Mobilya Montaj (Eski)" },
  { key: "washing", label: "Yıkama (Eski)" },
  { key: "delivery", label: "Teslimat (Eski)" },
  { key: "gas", label: "Gaz (Eski)" },
  { key: "windows", label: "Pencere (Eski)" },
  { key: "roof", label: "Çatı Kapağı (Eski)" },
  { key: "assembly", label: "Montaj (Eski)" },
  { key: "tse", label: "TSE (Eski)" },
  { key: "qc", label: "Kalite Kontrol (Eski)" },
];

export const TASK_STATUSES = [
  { key: "pending", label: "Beklemede", color: "slate" },
  { key: "in_progress", label: "Devam Ediyor", color: "blue" },
  { key: "submitted", label: "Onay Bekliyor", color: "amber" },
  { key: "chief_approved", label: "Şef Onayladı (%50)", color: "cyan" },
  { key: "approved", label: "Onaylandı (%100)", color: "emerald" },
  { key: "rejected", label: "Reddedildi", color: "red" },
  { key: "completed", label: "Tamamlandı", color: "emerald" },
  { key: "blocked", label: "Engellendi", color: "red" },
];

// Puan sistemi: her departmana özel baz puan
export const DEPT_BASE_POINTS = {
  accessory: 25, insulation: 20, water: 25, electrical: 30,
  furniture_prod: 40, furniture_asm: 35, leak_test: 20, washing: 15,
  // legacy
  furniture: 40, gas: 20, windows: 15, roof: 10, assembly: 35, tse: 25, qc: 40, cleaning: 10,
};

export const DEPT_CATEGORY = {
  accessory: "Aksesuar & Ön Ekipman", insulation: "İzolasyon",
  water: "Su Tesisatı", electrical: "Elektrik Tesisatı",
  furniture_prod: "Mobilya Üretim", furniture_asm: "Mobilya Montaj",
  leak_test: "Su Sızıntı Testi", washing: "Son Yıkama",
  // legacy
  furniture: "Mobilya Montajı", gas: "Gaz Tesisatı", windows: "Pencere & Çatı",
  roof: "Çatı Kapağı", assembly: "Mutfak / Montaj", tse: "TSE / Ön Kontrol",
  qc: "Son Kontrol", cleaning: "Temizlik & Teslim",
};

export const USER_ROLES = [
  { key: "admin", label: "Yönetici" },
  { key: "management", label: "Yönetim" },
  { key: "architect", label: "Mimar / Proje Sorumlusu" },
  { key: "purchasing", label: "Satın Alma" },
  { key: "production", label: "Üretim İşçisi" },
  { key: "electrical", label: "Elektrik" },
  { key: "water", label: "Su" },
  { key: "furniture", label: "Mobilya" },
  { key: "gas", label: "Gaz" },
  { key: "service", label: "Servis" },
  { key: "accounting", label: "Muhasebe" },
];

export const PAYMENT_STATUSES = [
  { key: "pending", label: "Bekliyor", color: "amber" },
  { key: "paid", label: "Ödendi", color: "emerald" },
  { key: "late", label: "Gecikti", color: "red" },
];

export const PURCHASING_STATUSES = [
  { key: "waiting", label: "Bekliyor", color: "slate" },
  { key: "ordered", label: "Sipariş Verildi", color: "blue" },
  { key: "partial", label: "Kısmen Teslim", color: "amber" },
  { key: "delivered", label: "Teslim Alındı", color: "emerald" },
];

export const CONTRACT_STATUSES = [
  { key: "draft", label: "Taslak", color: "slate" },
  { key: "sent", label: "Gönderildi", color: "blue" },
  { key: "signed", label: "İmzalandı", color: "emerald" },
  { key: "cancelled", label: "İptal", color: "red" },
  { key: "completed", label: "Tamamlandı", color: "green" },
];

export const QUOTATION_STATUSES = [
  { key: "draft", label: "Taslak", color: "slate" },
  { key: "sent", label: "Gönderildi", color: "blue" },
  { key: "approved", label: "Onaylandı", color: "emerald" },
  { key: "rejected", label: "Reddedildi", color: "red" },
];

export const TSE_CHECKLIST_ITEMS = [
  { key: "registration", label: "Araç Ruhsatı Yüklendi" },
  { key: "vin", label: "VIN Doğrulandı" },
  { key: "photos", label: "Araç Fotoğrafları Yüklendi" },
  { key: "docs", label: "Belgeler Tamamlandı" },
  { key: "project", label: "Proje Açıldı" },
  { key: "approval", label: "Onay Tamamlandı" },
];

export const QC_CHECKLIST_ITEMS = [
  { key: "electrical", label: "Elektrik Testi" },
  { key: "water", label: "Su Testi" },
  { key: "gas", label: "Gaz Testi" },
  { key: "window", label: "Pencere Testi" },
  { key: "roof", label: "Çatı Kapağı Testi" },
  { key: "furniture", label: "Mobilya Kontrolü" },
  { key: "cleaning", label: "Temizlik Kontrolü" },
  { key: "delivery_docs", label: "Teslimat Belgeleri" },
  { key: "photos", label: "Fotoğraf Yüklemesi" },
  { key: "video", label: "Video Yüklemesi" },
];

export const NAV_MODULES = [
  { path: "/", label: "Kontrol Paneli", icon: "LayoutDashboard", roles: "*" },
  { path: "/customers-vehicles", label: "Müşteri & Araç", icon: "Users", roles: ["admin", "management", "architect"] },
  { path: "/tse-tuv", label: "TSE & TÜV", icon: "ShieldCheck", roles: ["admin", "management", "architect", "engineer"] },
  { path: "/tuv-upload", label: "TÜV Raporu Ekle", icon: "Camera", roles: "*" },
  { path: "/architect", label: "Mimar Panosu", icon: "Ruler", roles: ["admin", "management", "architect"] },

  // ÜRETİM grubu
  { path: "/wall", label: "Üretim Duvarı", icon: "MonitorPlay", roles: ["admin", "management", "architect"], group: "Üretim" },
  { path: "/karoser",           label: "1. Karoser",             icon: "PackagePlus",  roles: ["admin", "management", "architect", "production"], dept: "karoser", group: "Üretim" },
  { path: "/water",             label: "2. Su Bölümü",           icon: "Droplets",     roles: ["admin", "management", "architect", "water", "production"], dept: "water", group: "Üretim" },
  { path: "/electrical",        label: "3. Elektrik Bölümü",     icon: "Zap",          roles: ["admin", "management", "architect", "electrical", "production"], dept: "electrical", group: "Üretim" },
  { path: "/furniture",         label: "4. Mobilya",             icon: "Armchair",     roles: ["admin", "management", "architect", "furniture", "production"], dept: "furniture", group: "Üretim" },
  { path: "/washing-delivery",  label: "5. Yıkama & Teslimat",   icon: "Sparkles",     roles: ["admin", "management", "architect", "production"], dept: "washing_delivery", group: "Üretim" },

  // Genel akış
  { path: "/production", label: "Üretim Özet", icon: "Factory", roles: "*" },
  { path: "/deliveries",     label: "Teslimatlar", icon: "PackageCheck", roles: "*" },
  { path: "/scan", label: "İş Emri Tara", icon: "ScanLine", roles: "*" },
  { path: "/purchasing-stock", label: "Satın Alma & Stok", icon: "PackageSearch", roles: ["admin", "management", "architect", "purchasing"] },
  { path: "/purchasing-scan", label: "Fatura Tara", icon: "Camera", roles: ["admin", "management", "purchasing"] },

  // SÖZLEŞMELER grubu (Sözleşmeler ana + Teklifler alt)
  { path: "/contracts", label: "Sözleşmeler", icon: "ScrollText", roles: ["admin"], owners_only: true, group: "Sözleşmeler" },
  { path: "/quotations", label: "Teklifler", icon: "FileText", roles: ["admin"], owners_only: true, group: "Sözleşmeler" },
  { path: "/package-reservations", label: "Ön Paket Ayırma", icon: "BookmarkCheck", roles: ["admin", "management"], owners_only: true, group: "Sözleşmeler" },

  // ÖDEMELER grubu
  { path: "/tse-tuv/payments", label: "Mühendis Ödemeleri", icon: "BadgeDollarSign", roles: ["admin", "engineer"], group: "Ödemeler" },
  { path: "/delivery-notices", label: "Teslimat Ödeme Bildirisi", icon: "Receipt", roles: ["admin", "architect", "management"], owners_only: true, group: "Ödemeler" },
  { path: "/my-payments", label: "Taşeron Ödemeleri", icon: "Wallet", roles: ["admin", "management"], owners_only: true, group: "Ödemeler" },
  { path: "/payments", label: "Ödemeler", icon: "CreditCard", roles: ["admin"], owners_only: true, group: "Ödemeler" },
  { path: "/finance", label: "Finans", icon: "Wallet", roles: ["admin"], owners_only: true, group: "Ödemeler" },

  // SERVİS grubu
  { path: "/service", label: "Servis Kayıtları", icon: "Wrench", roles: ["admin", "management", "architect", "service"], group: "Servis" },
  { path: "/service/appointments", label: "Randevular", icon: "CalendarClock", roles: ["admin", "management", "architect", "service"], group: "Servis" },
  { path: "/service-receipts", label: "Servis Dekontları", icon: "ReceiptText", roles: ["admin", "management", "architect", "accounting"], owners_only: true, group: "Servis" },

  // İŞLETME AYARLARI grubu
  { path: "/settings", label: "Ayarlar", icon: "Settings", roles: ["admin", "management"], group: "İşletme Ayarları" },
  { path: "/help", label: "Yardım", icon: "HelpCircle", roles: "*", group: "İşletme Ayarları" },
  { path: "/trash", label: "Silinenler", icon: "Trash2", roles: ["admin", "management"], group: "İşletme Ayarları" },
  { path: "/users", label: "Kullanıcılar", icon: "UserCog", roles: ["admin"], group: "İşletme Ayarları" },
  { path: "/whatsapp", label: "WhatsApp Hatları", icon: "MessageCircle", roles: ["admin", "management"], group: "İşletme Ayarları" },
  { path: "/reports", label: "Raporlar", icon: "BarChart3", roles: ["admin", "management", "architect"], owners_only: true, group: "İşletme Ayarları" },
  { path: "/admin/uptime", label: "Sistem Durumu", icon: "Activity", roles: ["admin", "management"], group: "İşletme Ayarları" },
  { path: "/admin/backup-access", label: "Yedek Sistem QR", icon: "QrCode", roles: ["admin", "management"], group: "İşletme Ayarları" },
];

// Modules that a "pure worker" (blue-collar production employee with no chief
// duties) is allowed to see. Everything else (finance, purchasing, vehicles list,
// deliveries, inventory, other departments, reports) is hidden so their menu
// stays uncluttered and focused on the work they actually perform.
const WORKER_ALLOWED_PATHS = new Set(["/", "/help", "/scan"]);

/** Returns true if the module should be shown in the sidebar for this user. */
export const FINANCE_OWNER_EMAILS = [
  "admin@akb.com",
  "info@akbkaravan.com",
  "muhasebe@akbkaravan.com",  // Mali müşavir
];

// Hukuk müşaviri — Compliance panosuna READ-ONLY + yorum ekleme yetkisi
export const LEGAL_ADVISOR_EMAILS = [
  "hukuk@akbkaravan.com",
];

export function isFinanceOwner(user) {
  const email = ((user?.email) || "").toLowerCase().trim();
  return FINANCE_OWNER_EMAILS.includes(email);
}

export function isLegalAdvisor(user) {
  const email = ((user?.email) || "").toLowerCase().trim();
  return LEGAL_ADVISOR_EMAILS.includes(email);
}

export function isFinanceOrLegal(user) {
  return isFinanceOwner(user) || isLegalAdvisor(user);
}

export function isModuleVisibleForUser(module, user) {
  if (!user) return false;
  const role = user.role;

  // Legal advisor — sadece Compliance panosunu görür
  if (role === "legal") {
    return module.path === "/finance/compliance";
  }

  // Engineer (Hasan) — sadece TSE/TÜV modüllerini görür
  if (role === "engineer") {
    return module.path === "/tse-tuv" || module.path === "/tse-tuv/payments";
  }

  // owners_only: modül sadece FINANCE_OWNER_EMAILS whitelist'inde. Admin bile
  // olsan whitelist'te değilsen görmezsin. (Ödemeler, Teklifler, Sözleşmeler,
  // Dekontlar, Raporlar gibi mali modüller için kullanılır.)
  if (module.owners_only) {
    return isFinanceOwner(user);
  }

  // Email allowlist — used for user-specific modules like /my-payments for
  // subcontractors.  If the module has `emails` and the current user's
  // email is in the list, they see it regardless of role.
  if (Array.isArray(module.emails) && user.email &&
      module.emails.includes((user.email || "").toLowerCase())) {
    return true;
  }

  if (role === "admin") return true;

  // Base role gate
  const roleOk = module.roles === "*" || (Array.isArray(module.roles) && module.roles.includes(role));
  if (!roleOk) return false;

  // Department-scoped modules: only the assigned workers + their chiefs + mgmt/architect see them.
  if (module.dept) {
    if (["management", "architect"].includes(role)) return true;
    const myDept = user.department;
    const chiefOf = Array.isArray(user.chief_of) ? user.chief_of : [];
    return myDept === module.dept || chiefOf.includes(module.dept);
  }

  // Pure worker: production role AND not a chief of anything.
  const chiefOf = Array.isArray(user.chief_of) ? user.chief_of : [];
  const isPureWorker = role === "production" && chiefOf.length === 0;
  if (isPureWorker) {
    return WORKER_ALLOWED_PATHS.has(module.path);
  }

  return true;
}

export function statusColor(color) {
  const map = {
    slate: "bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700",
    blue: "bg-blue-50 text-blue-700 border-blue-200 dark:bg-blue-950 dark:text-blue-300 dark:border-blue-900",
    amber: "bg-amber-50 text-amber-700 border-amber-200 dark:bg-amber-950 dark:text-amber-300 dark:border-amber-900",
    emerald: "bg-emerald-50 text-emerald-700 border-emerald-200 dark:bg-emerald-950 dark:text-emerald-300 dark:border-emerald-900",
    green: "bg-green-50 text-green-700 border-green-200 dark:bg-green-950 dark:text-green-300 dark:border-green-900",
    red: "bg-red-50 text-red-700 border-red-200 dark:bg-red-950 dark:text-red-300 dark:border-red-900",
    orange: "bg-orange-50 text-orange-700 border-orange-200 dark:bg-orange-950 dark:text-orange-300 dark:border-orange-900",
    purple: "bg-purple-50 text-purple-700 border-purple-200 dark:bg-purple-950 dark:text-purple-300 dark:border-purple-900",
    indigo: "bg-indigo-50 text-indigo-700 border-indigo-200 dark:bg-indigo-950 dark:text-indigo-300 dark:border-indigo-900",
  };
  return map[color] || map.slate;
}

export function findStatus(list, key) {
  return list.find(s => s.key === key) || { key, label: key, color: "slate" };
}
